import { render, staticRenderFns } from "./teacherForm.vue?vue&type=template&id=37cdda7a&"
import script from "./teacherForm.vue?vue&type=script&lang=js&"
export * from "./teacherForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports